//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapState } from "vuex";

export default {
    name: "AQPdfViewer",
    props: {
        pdfPath: { default: "" },
        fileUUID: { type: String, default: "" },
        title: { type: String, default: "" },
        canDownload: { type: Boolean, default: false },
        fieldCode: { type: String, default: "" },
        uploadCleared: { type: Boolean, default: false },
        logAudit: { type: Boolean, default: false }
    },
    data() {
        return {
            canvasElem: null,
            pageNumPending: null,
            scale: 1,
            pdfDoc: null,
            totalPages: 0,
            currentPage: 1,
            fileUrl: "",
            zoomLevel: 1.0,
            zoomStep: 0.1,
            maxZoom: this.isSmallScreen ? 1.5 : 2.0,
            minZoom: this.isSmallScreen ? 0.1 : 0.3,
            renderContainer: null,
            nativeScroll: true,
            winboxInstance: null,
            closeClicked: false
        };
    },
    computed: {
        ...mapState("components", ["isSmallScreen"]),
        getFileType() {
            let typeToReturn = "";
            if (this.pdfPath) {
                const lastDotIndex = this.pdfPath.lastIndexOf(".");
                const fileExtension = this.pdfPath.substring(lastDotIndex + 1);
                if (fileExtension.toLowerCase() === "pdf") {
                    typeToReturn = "pdf";
                } else if (["jpeg", "png", "svg", "jpg", "bmp"].includes(fileExtension.toLowerCase())) {
                    typeToReturn = "photo";
                }
            }
            return typeToReturn;
        }
    },
    watch: {
        scale: {
            handler(val) {
                this.renderContainer.style.zoom = val;
            }
        },
        uploadCleared(val) {
            if (val && this.winboxInstance) {
                this.winboxInstance.close();
                this.$emit("closeDialog");
            }
        }
    },
    mounted() {
        const vueInstance = this;
        const { WinBox } = window;
        this.winboxInstance = WinBox.new({
            title: this.title,
            id: `winbox-${this.fieldCode}`,
            class: this.isSmallScreen ? "winbox-upload mobile" : "winbox-upload",
            width: this.isSmallScreen ? "320px" : "600px",
            height: `${window.innerHeight - 130}px`,
            minwidth: this.isSmallScreen ? 305 : 401,
            minheight: 200,
            x: "center",
            y: "center",
            mount: document.getElementsByClassName("page-toolbar-container")[0],
            onclose() {
                vueInstance.closeClicked = true;
                vueInstance.$emit("closeDialog");
            }
        });
        if (!this.isSmallScreen) {
            const winboxCounter = document.getElementsByClassName("winbox-upload").length;
            const winboxElem = document.getElementById(`winbox-${this.fieldCode}`);
            winboxElem.style.left = `${winboxElem.getBoundingClientRect().x + 20 * (winboxCounter - 1)}px`;
        }
        this.scale = 1;
        this.renderContainer = document.getElementById(this.fieldCode);
        this.renderContainerWrapper = document.getElementById(`${this.fieldCode}-wrapper`);
        this.renderContainer.style.zoom = 1;
        this.renderContainerWrapper.addEventListener("scroll", () => {
            if (this.getFileType !== "pdf") { return; }

            if (this.nativeScroll) {
                document.querySelector(`[id='winbox-${this.fieldCode}'] input`).blur();
                const canvases = document.querySelectorAll(`[id='${this.fieldCode}'] canvas`);
                const containerTop = this.renderContainerWrapper.getBoundingClientRect().top;
                canvases.forEach(canvas => {
                    const canvasRect = canvas.getBoundingClientRect();
                    const canvasTop = canvasRect.top - containerTop;
                    if (canvasTop <= this.renderContainerWrapper.clientHeight / 2 && canvasTop + canvasRect.height >= 0) {
                        this.currentPage = Number(canvas.id.split("page")[1]);
                    }
                    return true;
                });
            } else {
                this.nativeScroll = true;
            }
        });
        setTimeout(() => {
            const iframe = document.createElement("iframe");
            iframe.src = `/data/attachment/download/attachment/${this.fileUUID}`;
            this.fileUrl = iframe.src;
            if (this.getFileType === "pdf") {
                const { pdfjsLib } = window;
                pdfjsLib.GlobalWorkerOptions.workerSrc = "../../../../assets/static/PdfJS/pdf.worker.min.js";
                pdfjsLib.getDocument(this.fileUrl).promise.then((pdfDoc_) => {
                    this.pdfDoc = pdfDoc_;
                    this.totalPages = this.pdfDoc.numPages;
                    this.renderPage(this.currentPage);
                });
            } else if (this.getFileType === "photo") {
                this.renderContainer.appendChild(document.getElementById(`photo-container-${this.fieldCode}`));
            } else {
                this.renderContainer.appendChild(document.getElementById(`fallback-container-${this.fieldCode}`));
            }
        }, 0);
    },
    beforeDestroy() {
        if (!this.closeClicked) {
            this.winboxInstance.close();
            this.$emit("closeDialog");
        }
    },
    methods: {
        applyZoom() {
            const image = document.querySelector(`[id='photo-container-${this.fieldCode}'] #zoomable-image`);
            image.style.transform = `scale(${this.zoomLevel})`;
            this.renderContainer.style.zoom = this.zoomLevel;
        },
        zoomMethod(fromZoomOut) {
            if (this.getFileType === "pdf") {
                if (fromZoomOut && this.scale > this.minZoom) {
                    this.scale -= 0.1;
                } else if (!fromZoomOut) {
                    this.scale += 0.1;
                }
            } else {
                if (fromZoomOut && this.zoomLevel > this.minZoom) {
                    this.zoomLevel -= this.zoomStep;
                } else if (!fromZoomOut && this.zoomLevel < this.maxZoom) {
                    this.zoomLevel += this.zoomStep;
                }
                this.applyZoom();
            }
            setTimeout(() => { this.scrollToPage(this.currentPage); }, 0);
        },
        resetToDefault() {
            if (this.getFileType === "pdf") {
                this.scale = this.isSmallScreen ? 0.7 : 1;
            } else {
                this.zoomLevel = 1.0;
                this.applyZoom();
            }
            setTimeout(() => { this.scrollToPage(this.currentPage); }, 0);
        },
        // Get page info from document, resize canvas accordingly, and render page.
        renderPage(num) {
            if (num) {
                this.pdfDoc.getPage(num).then(page => {
                    const winboxWidth = this.winboxInstance.body.clientWidth;
                    const winboxHeight = this.winboxInstance.body.clientHeight;
                    const viewport = page.getViewport({ scale: 1 });
                    const scale = Math.min(winboxWidth / viewport.width, winboxHeight / viewport.height);
                    const resolutionScale = this.isSmallScreen ? 3 : 2;
                    const scaledViewport = page.getViewport({ scale: scale * resolutionScale });
                    this.canvasElem = document.createElement("canvas");
                    this.renderContainer.appendChild(this.canvasElem);
                    this.canvasElem.setAttribute("id", `page${num}`);
                    this.canvasElem.height = scaledViewport.height;
                    this.canvasElem.width = scaledViewport.width;
                    this.canvasElem.style.height = `${scaledViewport.height / resolutionScale}px`;
                    this.canvasElem.style.width = `${scaledViewport.width / resolutionScale}px`;
                    this.canvasElem.style.display = "block";
                    this.canvasElem.style.marginBottom = "10px";

                    const context = this.canvasElem.getContext("2d");
                    const renderContext = {
                        canvasContext: context,
                        viewport: scaledViewport
                    };
                    const renderTask = page.render(renderContext);
                    // Wait for rendering to finish
                    renderTask.promise.then(() => {
                        if (num < this.totalPages) {
                            this.renderPage(++num);
                        }
                    });
                });
            }
        },
        downloadDoc() {
            const iframe = document.createElement("iframe");
            iframe.style.display = "none";
            if (this.logAudit) {
                const taskId = window.sessionStorage.getItem("taskId") || "";
                iframe.src = `/data/attachment/download/attachment/${this.fileUUID}?taskId=${taskId}`;
            } else {
                iframe.src = `/data/attachment/download/attachment/${this.fileUUID}`;
            }
            document.body.appendChild(iframe);

            setTimeout(() => {
                document.body.removeChild(iframe);
            }, 5000);
        },
        onPrevPage() {
            if (this.currentPage <= 1) {
                return;
            }
            this.currentPage--;
            this.scrollToPage(this.currentPage);
        },
        onNextPage() {
            if (this.currentPage >= this.pdfDoc.numPages) {
                return;
            }
            this.currentPage++;
            this.scrollToPage(this.currentPage);
        },
        scrollToPage(page) {
            if (page > this.totalPages) {
                this.currentPage = this.totalPages;
                page = this.currentPage;
            }
            this.nativeScroll = false;
            if (this.getFileType === "pdf") {
                document.querySelector(`[id='${this.fieldCode}'] #page${page}`).scrollIntoView();
            }
        }
    }
};
